import React, { useEffect } from "react";

import { init } from "services/kakao";

export default function KakaoLoginButton() {
  useEffect(init, []);

  return <div id="kakaoIdLogin" />;
}
